export default [
    {
        header: "Gestión",
    },
    {
        title: "Portal",
        route: "home",
        icon: 'HomeIcon',
        resource: "PortalClient",
        action: "read",
    },
];
